import { deriveLabelAndPathFromUrl, derivePathFromUrl } from './utils';
import { labels } from './translations/labels';
import { urlKeys } from 'developer-docs-source/urlKeys';
const enUsKeys = urlKeys['en-us'];

/**
 * The shared absolute path for all routes within a secondary nav section.
 */

const referenceApiKeys = ['deprecated/overview', 'deprecated/social-media', 'analytics-and-events/custom-events/custom-event-definitions', 'analytics-and-events/custom-events/custom-event-completions', 'analytics-and-events/email-analytics', 'analytics-and-events/reporting', 'analytics-and-events/event-analytics', 'analytics-and-events/cookie-banner/cookie-banner-api', 'analytics-and-events/cookie-banner/google-consent-mode', 'analytics-and-events/tracking-code', 'automation/create-manage-workflows', 'automation/custom-workflow-actions', 'automation/custom-code-actions', 'automation/sequences', 'cms/blogs/blog-details', 'cms/blogs/blog-authors', 'cms/blogs/blog-posts', 'cms/blogs/blog-tags', 'cms/blogs/blog-topics', 'cms/blogs/blog-comments', 'cms/content-audit', 'cms/domains', 'cms/hubdb', 'cms/layouts', 'cms/media-bridge', 'cms/modules', 'cms/pages', 'cms/site-search', 'cms/source-code', 'cms/templates', 'cms/url-redirects', 'conversations/chat-widget-sdk', 'conversations/inbox-and-messages', 'conversations/create-custom-channels', 'conversations/visitor-identification', 'crm/associations/association-details', 'crm/associations/associations-schema', 'crm/commerce/carts', 'crm/commerce/discounts', 'crm/commerce/fees', 'crm/commerce/invoices', 'crm/commerce/orders', 'crm/commerce/payments', 'crm/commerce/quotes', 'crm/commerce/subscriptions', 'crm/commerce/taxes', 'crm/engagements/engagement-details', 'crm/engagements/calls', 'crm/engagements/communications', 'crm/engagements/email', 'crm/engagements/meetings', 'crm/engagements/notes', 'crm/engagements/postal-mail', 'crm/engagements/tasks', 'crm/extensions/calling-sdk', 'crm/extensions/crm-cards', 'crm/extensions/extension-details', 'crm/extensions/timeline', 'crm/extensions/video-conferencing', 'crm/exports', 'crm/imports', 'crm/lists', 'crm/contacts-timeline-embed', 'crm/objects/companies', 'crm/objects/contacts', 'crm/objects/custom-objects', 'crm/objects/deals', 'crm/objects/deal-splits', 'crm/objects/feedback-submissions', 'crm/objects/goals', 'crm/objects/line-items', 'crm/objects/products', 'crm/objects/tickets', 'crm/objects/schemas', 'crm/objects/leads', 'crm/owners', 'crm/pipelines', 'crm/properties', 'crm/sensitive-data', 'library/files', 'library/meetings', 'marketing/campaigns', 'marketing/forms', 'marketing/marketing-events', 'marketing/subscriptions', 'marketing/subscriptions-preferences', 'marketing/emails/transactional-emails', 'marketing/emails/marketing-emails', 'marketing/emails/single-send-api', 'marketing/calls-to-action-sdk', 'settings/account-activity-api', 'settings/account-information-api', 'settings/business-units-api', 'settings/currencies', 'settings/users/user-provisioning', 'settings/users/user-details', 'other-resources/error-handling', 'app-management/webhooks', 'app-management/oauth', 'app-management/feature-flags'];
const gettingStartedKeys = enUsKeys['getting-started'];
const cmsGuidesKeys = enUsKeys['guides/cms'];
const referenceUiComponentsKeys = enUsKeys['reference/ui-components'];
const crmGuidesKeys = enUsKeys['guides/crm'];
const apiGuidesKeys = enUsKeys['guides/api'];
const appGuidesKeys = enUsKeys['guides/apps'];
const cmsReferenceKeys = enUsKeys['reference/cms'];
const navDataFromList = list => list.reduce((acc, key) => {
  const labelAndPath = deriveLabelAndPathFromUrl(key);
  if (labelAndPath) {
    acc[`/${key}`] = labelAndPath;
  }
  return acc;
}, {});

/**
 * A combination of all supported API Reference (both legacy and non-legacy) and
 * API Guide supported partial url routes which maps to label and breadcrumb
 * data. The full urls would prepend /guide/api or /api to the url.
 *
 *
 * All of the URLs for which the breadcrumbs and labels can be derived solely from the URL are passed to the `navDataFromList` function.  That function returns the label and the path based on the URL.
 * In the case that the label cannot be derived solely from the URL (for instance, in places where the end part of the URL is /overview but the label should be something more specific), the label and path are defined directly in the object.
 */
export const keyToNavData = {
  '/reference/api': Object.assign({}, navDataFromList(referenceApiKeys), {
    '/overview': {
      label: labels.getSetUp,
      path: () => []
    },
    '/deprecated/overview': {
      label: labels.deprecated,
      path: () => []
    }
  }),
  '/getting-started': navDataFromList(gettingStartedKeys),
  '/guides/cms': Object.assign({}, navDataFromList(cmsGuidesKeys), {
    '/content/modules/hide-modules-and-sections': {
      label: labels.hideModulesAndSectionsFromEditor,
      path: derivePathFromUrl(['content', 'modules'])
    }
  }),
  '/reference/ui-components': navDataFromList(referenceUiComponentsKeys),
  '/guides/crm': Object.assign({
    '/overview': {
      label: labels.overview,
      path: () => []
    }
  }, navDataFromList(crmGuidesKeys)),
  '/guides/api': Object.assign({
    '/overview': {
      label: labels.apiDeveloperGuidesAndResources,
      path: () => []
    }
  }, navDataFromList(apiGuidesKeys)),
  '/guides/apps': navDataFromList(appGuidesKeys),
  '/reference/cms': Object.assign({}, navDataFromList(cmsReferenceKeys), {
    '/modules/files': {
      label: labels.moduleFiles,
      path: derivePathFromUrl(['modules'])
    },
    'serverless-functions': {
      label: labels.serverlessFunctionsReference,
      path: derivePathFromUrl([])
    }
  })
};